import React, { useRef } from "react";
import { useDrag, useDrop } from "react-dnd";
import "./Swatch.css";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

const SwatchDND = ({
  id,
  url,
  inPalette,
  index,
  movePaletteItem,
  removeSwatch,
}) => {
  

  const [{ isDragging }, dragRef] = useDrag({
    type: "item",
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [spec, dropRef] = useDrop({
    accept: "item",
    hover: (item, monitor) => {
      const dragIndex = item.index;
      const hoverIndex = index;
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      const hoverMiddleY =
        (hoverBoundingRect.left - hoverBoundingRect.right) / 2;
      const hoverActualY =
        monitor.getClientOffset().x - hoverBoundingRect.right;

      if (dragIndex < hoverIndex && hoverActualY <= hoverMiddleY) {
        return;
      } else if (dragIndex > hoverIndex && hoverActualY >= hoverMiddleY) {
        return;
      }

      movePaletteItem(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });

  const ref = useRef(null);
  const dragDropRef = dragRef(dropRef(ref));

  const pageDisplay = (
    <div className="swatch" ref={dragDropRef}>
      <img src={url} alt="pic" className={inPalette ? "image2" : "image"} />
      <p
        className={inPalette ? "deleteButton" : "deleteButtonOff"}
        onClick={() => removeSwatch(id)}
      >
        {<HighlightOffIcon style={{ fontSize: "1rem" }} />}
      </p>
      <p
        className={inPalette ? "photoLabelPalette" : "photoLabel"}
      >{`${id}`}</p>
    </div>
  );

  return <>{pageDisplay}</>;
};

export default SwatchDND;
